import {
  Badge,
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Text,
} from "@chakra-ui/react";
import { Icon } from "@iconify/react";

import React from "react";
import { useNavigate } from "react-router-dom";
import SectionWrapper from "../../components/SectionWrapper";

const ExploreMore = () => {
  const navigate = useNavigate();
  const exploreItems = [
    {
      title: "Design Library",
      icon: "material-symbols:library-books-outline",
      image:
        "https://blogs.airbrickinfra.com/wp-content/uploads/2023/09/cafe-piccasso-view-03-1024x576.jpg",
      navigation: "/showcase",
    },
    {
      title: "Mood board Generator",
      icon: "material-symbols:palette-outline",
      image:
        "https://blogs.airbrickinfra.com/wp-content/uploads/2023/04/Copy-of-23-03-100-e1681914364965-1024x665.png",
      navigation: "/moodboard",
    },
    {
      title: "Presentation",
      icon: "material-symbols:presentation-outline",
      image:
        "https://blogs.airbrickinfra.com/wp-content/uploads/2023/09/co-offiz_confrence_2023-08-23-scaled-e1695235741476-1024x576.jpg",
      navigation: "/project-showcase",
    },
    {
      title: "Previous Projects",
      icon: "material-symbols:folder-outline",
      image:
        "https://blogs.airbrickinfra.com/wp-content/uploads/2023/04/Copy-of-23-03-3-e1681914512426-1024x666.jpg",
      navigation: "/project-showcase",
    },
  ];
  return (
    <SectionWrapper heading={"Explore More"}>
      <>
        <Grid templateColumns="repeat(auto-fit, minmax(250px, 1fr))" gap={6}>
          {exploreItems.map((item, index) => (
            <GridItem key={index}>
              <Box
                className="bg-white rounded-xl border transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                overflow="hidden"
                onClick={() => navigate(item.navigation)}
              >
                <Box className="relative h-48 overflow-hidden">
                  <Image
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                  <Box className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                </Box>
                <Box p={4}>
                  <Flex justify={"center"} gap={3} w={"full"}>
                    {/* <Box
                      className="p-2 bg-teal-50 rounded-lg"
                    >
                      <Icon icon={item.icon} className="text-teal-600 text-xl" />
                    </Box> */}
                    <Text fontWeight="semibold" color="gray.800" fontSize="lg">
                      {item.title}
                    </Text>
                  </Flex>
                </Box>
              </Box>
            </GridItem>
          ))}
        </Grid>
      </>
    </SectionWrapper>
  );
};

export default ExploreMore;
